import CheckboxGroup from "../components/CheckboxGroup";
import FormHeader from "../components/FormHeader";
import RadioGroup from "../components/RadioGroup";
import Select from "../components/Select";
import PrimaryButton from "../components/Submit";

type IProps = {
  onNext: () => void;
  currentIndex: number;
  totalSteps: number;
};

function KnowledgeAndExperience(props: IProps) {
  return (
    <div className="form-container">
      <FormHeader title="Knowledge and Experience" />
      <form action="#" method="POST" onSubmit={(e) => e.preventDefault()}>
        <Select
          label="What percentage of your disposable / liquid assets do you intend to use to trade wit hCMC"
          placeholder=""
          className="select-full"
          options={[
            { key: "none", value: "0 - 20%" },
            { key: "beginner", value: "21 - 50%" },
            { key: "intermediate", value: "51 - 75%" },
            { key: "advanced", value: ">75%%" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <RadioGroup
          label="Are you aware that CFDs and Spread Bets are leveraged high risk products?"
          name="risk"
          options={[
            { key: "yes", value: "Yes" },
            { key: "no", value: "No" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          value="no"
        />

        <Select
          label="What are you planning to use this account for?"
          placeholder=""
          className="select-full"
          options={[
            {
              key: "intra-day",
              value: "Intra-day trading or market speculation",
            },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <CheckboxGroup
          label="Shares or bonds"
          name="sharesOrBonds"
          options={[
            { key: "shares", text: "Shares" },
            { key: "bonds", text: "Bonds" },
            { key: "trackersOrFunds", text: "Trackers or Funds" },
            { key: "cfds,spread,forex", text: "CFDs, Spread Bets, Forex" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          value={[">20"]}
        />
        <PrimaryButton type="button" onClick={props.onNext} loading={false}>
          Next
        </PrimaryButton>
      </form>
    </div>
  );
}

export default KnowledgeAndExperience;
